// extracted by css-extract-rspack-plugin
export default {"icon_button_override":"Kkqie","iconButtonOverride":"Kkqie","#":"n2x_a"};